import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { I18n } from 'components/translate';
import { PropTypes } from 'prop-types';

import ConfigStreamingToggle from './ConfigStreamingToggle';
import { labelsByStreamingCondition as labelsMap } from './constants';

import ConfigList from '../components/ConfigList';

import './ConfigStreaming.scss';

export default class ConfigStreaming extends Component {
  static propTypes = {
    streamingActive: PropTypes.boolean,
    streamingCondition: PropTypes.string,
    addOnCost: PropTypes.string,
    bundleAddOnCost: PropTypes.string,
    promotionalCost: PropTypes.string,
    tabIndex: PropTypes.number,
    onToggleChange: PropTypes.func
  };

  get renderImportant() {
    const { bundleAddOnCost } = this.props;

    return (
      <div className="streaming streaming__important mb__0">
        <label className="streaming__important__title">
          <FontAwesomeIcon icon={['fas', 'info-circle']} className="_mr-2" />
          <I18n label="general.important" />
        </label>
        <label className="streaming__important__description">
          <I18n
            html
            label="config_manager.config_streaming.activate_warning_3"
            data={{ value: bundleAddOnCost }}
          />
        </label>
        <label className="streaming__important__description">
          <I18n
            html
            label="config_manager.config_streaming.activate_warning_1"
          />
        </label>
      </div>
    );
  }

  render() {
    const streamingToggleId = 'streaming_toggle';
    const {
      streamingActive,
      streamingCondition,
      addOnCost,
      bundleAddOnCost,
      promotionalCost,
      onToggleChange
    } = this.props;

    return (
      <div className="grid grid__block config-streaming">
        <h2 className="mb__md config-streaming__title">
          <I18n label="config_manager.streaming_title" />
        </h2>
        <p>
          <I18n label="config_manager.config_streaming.description_v2" />
        </p>

        <ConfigList
          items={labelsMap[streamingCondition]}
          params={{
            addOnCost,
            promotionalCost
          }}
        />

        <p className="mb__md config-streaming__price">
          <I18n
            label="config_manager.config_streaming.rate_description"
            data={{
              value: addOnCost,
              value2: bundleAddOnCost
            }}
          />
        </p>

        <ConfigStreamingToggle
          label="config_manager.config_streaming.active_streaming_v2"
          toggleId={streamingToggleId}
          name={streamingToggleId}
          checked={streamingActive}
          onChange={onToggleChange}
        />

        {this.renderImportant}
      </div>
    );
  }
}
